const es = {
  "week.view": "Vista Semana",
  "month.view": "Vista Mes",
  "day.view": "Vista Dia",
  previous_month: "Anterior Mes",
  next_month: "Próximo Mes",
  previous_week: "Anterior Semana",
  next_week: "Próximo Semana",
  previous_day: "Anterior Dia",
  next_day: "Próximo Dia",
  schedule_appointment: "Agendar cita",
  upcoming_meetings: "Próximos Eventos",
  "menu.appointment_scheduling": "AGENDAMIENTO DE CITAS",
  "appointment_scheduling.scheduled_services.product": "Servicios",
  "appointment_scheduling.scheduled_services": "Servicios",
  "appointment_scheduling.scheduled_services.unit_price": "Precio",
  "appointment_scheduling.customer": "Cliente",
  "appointment_scheduling.patient": "Paciente",
  "appointment_scheduling.consumer": "Contacto",
  "appointment_scheduling.overbooking": "Sobre Reserva",
  "appointment_scheduling.non_billable": "No Facturable",
  "appointment_scheduling.number": "Numero",
  "appointment_scheduling.start_date": "Hora Inicio",
  "appointment_scheduling.end_date": "Hora Fin",
  "appointment_scheduling.availability": "Disponibilidad",
  "appointment_scheduling.locking": "Bloqueo",
  "appointment_scheduling.appointment_date": "Fecha",
  "appointment_scheduling.professional": "Profesional",
  "appointment_scheduling.product": "Producto",
  "appointment_scheduling.comment": "Comentario",
  "appointment_scheduling.show_up": "Presentado",
  "appointment_scheduling.show_up_message": "Cita presentada exitosamente",
  "appointment_scheduling.no_show_up": "No Presentado",
  "appointment_scheduling.no_show_up_message":
    "Cita marcada como no presentado",
  "appointment_scheduling.schedule": "Agendar",
  "appointment_scheduling.schedule_message": "Cita agendada exitosamente",
  "appointment_scheduling.add_new": "Agregar Cita",
  "appointment_scheduling.attended": "Atendido",
  "appointment_scheduling.attended_message": "Cita atendida exitosamente",
  "appointment_scheduling.cancel": "Cancelado",
  "appointment_scheduling.cancelled": "Cancelado",
  "appointment_scheduling.scheduled": "Agendado",
  "appointment_scheduling.messge_error": "Error agendando cita",
  "appointment_scheduling.draft": "Borrador",
  "appointment_scheduling.pending_sessions": "Sesiones Pendientes",
  appointment_scheduling: "AGENDAMIENTO DE CITAS",
  "appointment_scheduling.sale": "Venta",
  "appointment_scheduling.services": "Servicios",
  "appointment_scheduling.state": "Estado",
  "appointment_scheduling.page.appointment": "AGENDA",
  "appointment_scheduling.page.services": "SERVICIOS A FACTURAR",
  "appointment_scheduling.page.payments": "DETALLE DE PAGOS",
  "appointment_scheduling.page.history": "HISTORIAL",
  "appointment_scheduling.page.appointment_calendar": "APERTURA/BLOQUEO AGENDA",
  "account.statement.line.description": "Descripcion",
  "account.statement.line.sale": "Venta",
  "account.statement.statement": "Medio de pago",
  "account.statement.amount": "Valor a Pagar",
  "account.statement.voucher": "Voucher",
  "account.statement.pay": "Pagar",
  "sale.line.origin.appointment_date": "Fecha Entrega",
  "sale.sale.bill": "Facturar",
  "sale.sale.send_email": "Enviar Email",
  "appointment_scheduling.calendar": "DISPONIBILIDAD CALENDARIO",
  "appointment_scheduling.calendar.start_date": "Fecha Inicial",
  "appointment_scheduling.calendar.end_date": "Fecha Final",
  "appointment_scheduling.calendar.recurrence": "Recurrencia",
  "appointment_scheduling.calendar.type": "Tipo",
  "appointment_scheduling.calendar.professional": "Profesional",
  "appointment_scheduling.calendar.weekdays": "Dia de la Semana",
  "appointment_scheduling.calendar.recurrence_end_date":
    "Fecha Fin Recurrencia",
  "appointment_scheduling.calendar.state": "Estado",
  "appointment_scheduling.calendar.notes": "Notas",
  "appointment_scheduling.calendar.Locking": "Bloqueo",
  "appointment_scheduling.calendar.Availability": "Disponibilidad",
  "appointment_scheduling.calendar.Does not repeat": "No se Repite",
  "appointment_scheduling.calendar.Daily": "Diario",
  "appointment_scheduling.calendar.Weekly": "Semanal",
  "appointment_scheduling.calendar.Monthly": "Mensual",
  "appointment_scheduling.calendar.Custom": "Personalizado",
  "appointment_scheduling.calendar.all_day": "Todo el Dia",
  "appointment_scheduling.calendar.Monday": "Lunes",
  "appointment_scheduling.calendar.Tuesday": "Martes",
  "appointment_scheduling.calendar.Wednesday": "Miercoles",
  "appointment_scheduling.calendar.Thursday": "Jueves",
  "appointment_scheduling.calendar.Friday": "Viernes",
  "appointment_scheduling.calendar.Saturday": "Sabado",
  "appointment_scheduling.calendar.Sunday": "Domingo",
  "appointment_scheduling.calendar.schedule": "Programar",
  "account.statement.line.statement.state": "Estado",
  "party.consumer": "Contacto",
  "party.consumer.id_number": "Numero de Identificación",
  "party.consumer.name": "Nombre",
  "party.consumer.phone": "Teléfono",
  "party.consumer.address": "Dirección",
  "party.consumer.notes": "Notas",
  "sale.line.sale.sale_date": "Fecha Venta",
  "sale.line.sale": "Venta",
  "statement.line.print_voucher": "Imprimir Comprobante",
  dont_delete_payment_line:
    "No puedes eliminar un pago de un estado de cuenta en estado validado o cerrado",
  sheduled: "Agendado",
  "account.statement.other_income": "Otros Ingresos",
  "button.sales": "Ventas",
  "button.appointments": "Agendas",
  "menu.sales": "Ventas",
  "menu.reports": "Reportes",
  "menu.invoices": "Facturas",
  "menu.rest_order_tabs": "KDS",
  "sale.sale.all": "Todo",
  "sale.sale.none": "Sin Factura",
  "sale.sale.awaiting payment": "Pago Pendiente",
  "sale.sale.done": "Finalizada",
  "account.invoice.all": "Todo",
  "account.invoice.draft": "Borrador",
  "account.invoice.pending": "Pendiente",
  "account.invoice.posted": "Contabilizado",
  "appointment_scheduling.scheduling_mode": "Tipo Atención",
  "appointment_scheduling.room": "Salas",
  "appointment_scheduling.calendar.room": "Salas",
  "appointment_scheduling.edit": "Editar",
  calendar_appointment: "Calendario",
  "appointment_scheduling.reference": "Autorización",
  "appointment_scheduling.ingress_service_health": "Tipo Servicio de salud",
  "appointment_scheduling.description": "Descripción",
  "appointment_scheduling.service_order": "Orden de servicio",
  "appointment_scheduling.msg_professional_unavailable - ":
    "No hay disponibilidad",
  "appointment_scheduling.type_order": "Tipo de orden",
  "party.party.type_user_health": "Tipo de usuario",
  "appointment_scheduling.appointment_type": "Tipo de cita",
};

export default es;
